/**
 * Created by afuhr on 07.07.2016.
 */
/**
 * Created by afuhr on 07.07.2016.
 */
import {RouterModule, Routes} from "@angular/router";
import {StoreManagementComponent} from "./store-management.component";
import {StoreDashboardComponent} from "./store-dashboard/store-dashboard.component";
import {StockListComponent} from "./stock/stock-list/stock-list.component";
import {AuthorizedGuard} from "../shared/auth/guards/authorized-guard";
import {StockItemListViewComponent} from "./stock-item/stock-item-list-view/stock-item-list-view.component";
import {EditStockItemComponent} from "./stock-item/edit-stock-item/edit-stock-item.component";
import {AddStockItemComponent} from "./stock-item/add-stock-item/add-stock-item.component";
import {StockItemResolverService} from "./services/stock-item-resolver.service";
import {DepotListViewComponent} from "./depot/depot-list-view/depot-list-view.component";
import {WithdrawalComponent} from "./withdrawal/withdrawal.component";
import {SuppliersListComponent} from "../crm/supplier/suppliers-list/suppliers-list.component";
import {AddStocksTableViewComponent} from "./stock/add-stocks-table-view/add-stocks-table-view.component";
import {EditStockComponent} from "./stock/edit-stock/edit-stock.component";
import {StockResolverService} from "./services/resolvers/stock-resolver.service";
import {ShoppingCartsViewComponent} from "./procurement/shopping-carts-view/shopping-carts-view.component";
import {NewOrderComponent} from "./procurement/new-order/new-order.component";
import {OrderViewComponent} from "./procurement/order-view/order-view.component";
import {OrderListViewComponent} from "./procurement/order-list-view/order-list-view.component";
import {NewDeliveryComponent} from "./procurement/new-delivery/new-delivery.component";
import {IncomingGoodsViewComponent} from "./procurement/incoming-goods-view/incoming-goods-view.component";
import {MedicineBookViewComponent} from "./medicine/medicine-book-view/medicine-book-view.component";
import {WithdrawalLogViewComponent} from "./withdrawal/withdrawal-log-view/withdrawal-log-view.component";
import {ModuleWithProviders} from "@angular/core";
import {StoremanagementAuthorizedGuard} from "./guards/storemanagement-authorized.guard";
import {ConsumptionStatisticsViewComponent} from "./statistics/consumption-statistics-view/consumption-statistics-view.component";
import {OrderStatisticsViewComponent} from "./statistics/order-statistics-view/order-statistics-view.component";
import {InitStocktakingViewComponent} from "./stocktaking/views/init-stocktaking-view/init-stocktaking-view.component";
import {StocktakingViewComponent} from "./stocktaking/views/stocktaking-view/stocktaking-view.component";
import {MedicineStocksViewComponent} from "./medicine/medicine-stocks-view/medicine-stocks-view.component";
import {StocktakingsListViewComponent} from "./stocktaking/views/stocktakings-list-view/stocktakings-list-view.component";
import {MoveStocksViewComponent} from "./stock/views/move-stocks-view/move-stocks-view.component";
import {CheckProductBatchesViewComponent} from "./stock/views/check-product-batches-view/check-product-batches-view.component";
import {FillUpDepotViewComponent} from "./procurement/views/fill-up-depot-view/fill-up-depot-view.component";
import {AccountingUnitsViewComponent} from "./accounting-units-view/accounting-units-view.component";
import {RegisterAssetsForArticleViewComponent} from './asset-management/views/register-assets-for-article-view/register-assets-for-article-view.component';
import {RfidAutoStocktakingViewComponent} from './stocktaking/views/rfid-auto-stocktaking-view/rfid-auto-stocktaking-view.component';
import {AssetListViewComponent} from './asset-management/views/asset-list-view/asset-list-view.component';
import {GenerateInvoiceViewComponent} from './procurement/views/generate-invoice-view/generate-invoice-view.component';
import {InvoiceViewComponent} from './procurement/views/invoice-view/invoice-view.component';
import {InvoicesListViewComponent} from './procurement/views/invoices-list-view/invoices-list-view.component';
import {AssetMarriageViewComponent} from './asset-management/views/asset-marriage-view/asset-marriage-view.component';
import {AccountNumbersListViewComponent} from '../crm/views/account-numbers-list-view/account-numbers-list-view.component';
import {LocationMarriageWizzardViewComponent} from './asset-management/views/location-marriage-wizzard-view/location-marriage-wizzard-view.component';

export const storageRoutes: Routes = [

  {
    path: 'lagerverwaltung',
    component: StoreManagementComponent,
    canActivate: [AuthorizedGuard, StoremanagementAuthorizedGuard],
    children: [
      {
        path: '',
        canActivateChild: [AuthorizedGuard, StoremanagementAuthorizedGuard],
        children: [
          {
            path: 'dashboard',
            redirectTo: '',
            pathMatch: 'full'
          },

          {
            path: 'lager',
            children: [
              {
                path: '',
                component: DepotListViewComponent
              },
              {
                path: ':depotCuid/bestand',
                children: [
                  {
                    path: '',
                    component: StockListComponent
                  },
                  {
                    path: 'neu',
                    component: AddStocksTableViewComponent
                  },
                  {
                    path: 'bedarf',
                    component: FillUpDepotViewComponent
                  },
                  {
                    path: ':cuid/edit',
                    component: EditStockComponent,
                    resolve: {
                      stock: StockResolverService
                    }
                  },
                ]
              },
            ]
          },

          {
            path: 'artikel',
            children: [
              {
                path: '',
                component: StockItemListViewComponent,
              },
              {
                path: 'neu',
                component: AddStockItemComponent
              },
              {
                path: ':cuid/edit',
                component: EditStockItemComponent,
                resolve: {
                  stockItem: StockItemResolverService
                }
              },
              {
                path: ':cuid/gegenstaende/registrieren',
                component: RegisterAssetsForArticleViewComponent,
                resolve: {
                  stockItem: StockItemResolverService
                }
              },
            ]
          },

          {
            path: 'teile',
            children: [
              {
                path: 'neue-hierarchie',
                component: AssetMarriageViewComponent,
              },
              {
                path: 'standort-zuordnen',
                component: LocationMarriageWizzardViewComponent,
              },
              {
                path: '',
                component: AssetListViewComponent,
              },
            ]
          },

          {
            path: 'bestand',
            children: [
              {
                path: '',
                component: StockListComponent
              },
              {
                path: 'neu',
                component: AddStocksTableViewComponent
              },
              // Storage-Mgmt
              {
                path: 'entnahme',
                component: WithdrawalComponent
              },
              {
                path: 'verschieben',
                component: MoveStocksViewComponent
              },
              {
                path: 'protokoll',
                component: WithdrawalLogViewComponent
              },
              {
                path: 'chargen',
                component: CheckProductBatchesViewComponent
              },
              {
                path: 'medikamente',
                children: [
                  {
                    path: '',
                    component: MedicineStocksViewComponent
                  },
                  {
                    path: 'verbrauch/:medicineStockCuid',
                    component: MedicineBookViewComponent
                  },
                ]
              },
              {
                path: ':cuid',
                component: EditStockComponent, //TODO: Add stock detail page
                resolve: {
                  stock: StockResolverService
                }
              },
              {
                path: ':cuid/edit',
                component: EditStockComponent,
                resolve: {
                  stock: StockResolverService
                }
              },
            ]
          },

          {
            path: 'inventur',
            children: [
              {
                path: '',
                component: StocktakingsListViewComponent
              },
              {
                path: 'neu',
                component: InitStocktakingViewComponent
              },
              {
                path: 'rfid',
                component: RfidAutoStocktakingViewComponent
              },
              {
                path: ':stocktakingCuid',
                component: StocktakingViewComponent
              }
            ]
          },

          {
            path: 'bestellungen',
            children: [
              {
                path: '',
                component: OrderListViewComponent
              },
              {
                path: 'offen',
                component: IncomingGoodsViewComponent,
              },
              {
                path: 'offen/:orderCuid/wareneingang',
                component: NewDeliveryComponent
              },
              {
                path: ':orderCuid',
                component: OrderViewComponent
              },
            ]
          },

          {
            path: 'warenkorb',
            children: [
              {
                path: '',
                component: ShoppingCartsViewComponent
              },
              {
                path: ':shoppingCartCuid/bestellung',
                component: NewOrderComponent
              },
            ]
          },

          {
            path: 'zentrallager',
            children: [
              {
                path: '',
                redirectTo: 'bedarf',
                pathMatch: 'full'
              },
              {
                path: 'bedarf',
                component: FillUpDepotViewComponent
              },
              {
                path: 'rechnungen',
                children: [
                  {
                    path: 'erzeugen',
                    component: GenerateInvoiceViewComponent
                  },
                  {
                    path: ':invoiceCuid',
                    component: InvoiceViewComponent
                  },
                  {
                    path: '',
                    component: InvoicesListViewComponent
                  },
                ]
              },
            ]
          },

          {
            path: 'lieferanten',
            children: [
              {
                path: '',
                component: SuppliersListComponent,
                pathMatch: 'full'
              },
              {
                path: 'neu',
                redirectTo: ''
              }
            ]
          },

          {
            path: 'kostenstellen',
            children: [
              {
                path: '',
                component: AccountingUnitsViewComponent,
                pathMatch: 'full'
              },
              {
                path: 'buchungskonten',
                component: AccountNumbersListViewComponent
              },
              {
                path: 'neu',
                redirectTo: ''
              }
            ]
          },

          {
            path: 'statistik',
            children: [
              {
                path: 'verbrauch',
                component: ConsumptionStatisticsViewComponent
              },
              {
                path: 'beschaffung',
                component: OrderStatisticsViewComponent
              },
              {
                path: '',
                redirectTo: 'verbrauch',
                pathMatch: 'full'
              }
            ]
          },

          {
            path: '',
            component: StoreDashboardComponent
          }
        ]
      }
    ]
  },
];

export const storageRouting: ModuleWithProviders = RouterModule.forChild(storageRoutes);



// WEBPACK FOOTER //
// ./src/app/store-management/store-management.routes.ts